import {z} from 'zod';
import {
	editRemovesFromFilter,
	getDefaultFilters,
	makeOptionalPropsNullable,
	type EditRemovesFromFilterParams,
	type GetDefaultFiltersParams,
} from '@netx/core-schema';
import {PersonSchema, type IPerson, PersonField} from './personSchema';

export const PersonFilterSchema = makeOptionalPropsNullable(
	PersonSchema.partial().pick({
		[PersonField.name]: true,
		[PersonField.status]: true,
	}),
);

export const PersonFilterableField = PersonFilterSchema.keyof().enum;

export const PERSON_FILTERABLE_FIELDS = Object.values(PersonFilterableField);

export type IPersonFilter = z.infer<typeof PersonFilterSchema>;

/** will return the filters passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getPersonDefaultFilters = (
	params?: Omit<GetDefaultFiltersParams<IPersonFilter>, 'filterableFields'>,
): IPersonFilter =>
	getDefaultFilters({
		...params,
		filterableFields: PERSON_FILTERABLE_FIELDS,
	});

/** given the original data, the new data, and the current filters, determine if the record should still be included in the filtered list */
export const personEditRemovesFromFilter = (
	params: Omit<EditRemovesFromFilterParams<IPerson, IPersonFilter>, 'schema'>,
) =>
	editRemovesFromFilter({
		...params,
		schema: PersonSchema,
	});
